import request from '@/utils/request'

// ==================== 门店申请相关 ====================

// 提交门店申请入驻
export function createStoreApplication(data) {
  return request({
    url: '/store/applications',
    method: 'post',
    data
  })
}

// 查询申请状态
export function getStoreApplication(applicationId) {
  return request({
    url: `/store/applications/${applicationId}`,
    method: 'get'
  })
}

// 审核门店申请
export function auditStoreApplication(applicationId, data) {
  return request({
    url: `/store/applications/${applicationId}/audit`,
    method: 'put',
    data
  })
}

// 获取申请列表
export function getStoreApplicationList(params) {
  return request({
    url: '/store/applications',
    method: 'get',
    params
  })
}

// ==================== 门店管理相关 ====================

// 获取门店信息
export function getStoreInfo(storeId) {
  return request({
    url: `/store/stores/${storeId}`,
    method: 'get'
  })
}

// 更新门店信息
export function updateStoreInfo(storeId, data) {
  return request({
    url: `/store/stores/${storeId}`,
    method: 'put',
    data
  })
}

// 生成推广二维码
export function generateStoreQRCode(storeId) {
  return request({
    url: `/store/stores/${storeId}/qrcode`,
    method: 'post'
  })
}

// 门店列表查询（支持手机号查询）
export function getStoreList(params) {
  return request({
    url: '/store/stores',
    method: 'get',
    params
  })
}

// 门店状态管理
export function updateStoreStatus(storeId, data) {
  return request({
    url: `/store/stores/${storeId}/status`,
    method: 'put',
    data
  })
}

// 删除门店
export function deleteStore(storeId, data) {
  return request({
    url: `/store/stores/${storeId}`,
    method: 'delete',
    data
  })
}

// ==================== 用户端门店相关 ====================

// 查询我申请的门店
export function getMyOwnedStores(params) {
  return request({
    url: '/store/my-owned-stores',
    method: 'get',
    params
  })
}

// 查询我的申请记录
export function getMyApplications(params) {
  return request({
    url: '/store/my-applications',
    method: 'get',
    params
  })
}

// 查询我绑定的门店
export function getMyBoundStore() {
  return request({
    url: '/store/my-bound-store',
    method: 'get'
  })
}

// ==================== 门店证书相关 ====================

// 获取门店授权证书列表
export function getStoreCertificates(storeId) {
  return request({
    url: `/stores/${storeId}/certificates`,
    method: 'get'
  })
}

// 获取门店最新授权证书
export function getStoreLatestCertificate(storeId) {
  return request({
    url: `/stores/${storeId}/certificates/latest`,
    method: 'get'
  })
}

// 上传门店证书照片
export function uploadCertificateImage(certificateId, formData) {
  return request({
    url: `/my-store/certificates/${certificateId}/upload-image`,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 删除门店证书照片
export function deleteCertificateImage(certificateId) {
  return request({
    url: `/my-store/certificates/${certificateId}/image`,
    method: 'delete'
  })
}

// 通过手机号查询门店证书
export function getCertificatesByPhone(phone) {
  return request({
    url: `/store/certificates/search/phone/${phone}`,
    method: 'get'
  })
}